export default "__VITE_ASSET__ZbgcvG0s__"